import { toast } from "sonner";
import { useMutation } from "@tanstack/react-query";
import { removeDeliverable } from "./api";
import { invalidateAllQueries } from "utils/utils";

export function useRemoveDeliverable(options = {}) {
    return useMutation({
        mutationFn: ({ id }) => removeDeliverable(id),
        onSuccess: () => {
            invalidateAllQueries();
            toast.success("Removed deliverable Successfully");
            options.onSuccess?.();
        },
        onError: () => {
            toast.error("Error Removing deliverable");
        },
    });
}